export const UPDATE_AVALIACOES = 'UPDATE_AVALIACOES';
export const AVALIACOES_REQUEST = 'AVALIACOES_REQUEST';
export const AVALIACOES_SUCCESS = 'AVALIACOES_SUCCESS';
export const AVALIACOES_FAILED = 'AVALIACOES_FAILED';
